export default __webpack_public_path__ + "static/media/edit-action.5d4e9acf.svg";